
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tItemUom/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tItemUom/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tItemUom/findPage',
        method: 'post',
      data
    })
}

// 查询分页数据
export const findPageByPara = (data) => {
  return axios({
    url: '/tItemUom/findPageByPara',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tItemUom.js